import Rest from '@/services/Rest';

export default class CertifyService extends Rest {
  static resource = 'certificate';
}
